import React, { useContext, useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import { ToastContainer, toast } from "react-toastify";
import Spinner from "../../loading/spinner";
import UpperbarContext from "../../context/upperbar-context";
import AuthContext from "../../context/auth-context";
import { Fetchdata } from "../../hooks/getData";
import "react-toastify/dist/ReactToastify.css";
import "../attendance/attendanceReport.css";
import { FaRegCalendarAlt } from "react-icons/fa";

export default function ManualAttendance() {
  const { User } = useContext(AuthContext);
  const { mode, appURL,expires, customStyles,todayDate, fiscalYear} = useContext(UpperbarContext);

  const [dataList, setDataList] = useState([]);
  const [loading, setLoading] = useState(true);

 
  const [branch, setBranch] = useState(User.BranchID || "1");

  
  useEffect(() => {
    fetchData();
  }, [ branch]);

  const fetchData = async () => {
    setLoading(true);
    const response = await Fetchdata({
      ComID: User.ComID,
      AuthCode: User.AuthCode,
      UserID: User.UID.to,
      BranchID: "1",
      Flag: "S",
      FetchURL: `${appURL}api/admin/staff-ot`,
      Type: "POST",
    });

    if (response.StatusCode === 200) {
      setDataList(response.Values);
    } else {
      setDataList([]);
      toast.error("Failed to load data");
    }
    setLoading(false);
  };

  const handleInputChange = (e, row, field) => {
    const updatedList = dataList.map((item) =>
      item.UserID === row.UserID ? { ...item, [field]: e.target.value } : item
    );
    setDataList(updatedList);
  };

  const handleSave = async () => {
    const payload = dataList.map((item) => ({
     UserID: item.UserID.toString(),
    OtAmount: item.OTValue.toString(),
    }));

    const response = await Fetchdata({
      ComID: User.ComID,
      AuthCode: User.AuthCode,
      UserID: User.UID.toString(),
      BranchID: "1",
      Flag: "i",
      Values: payload,
      FetchURL: `${appURL}api/admin/staff-ot`,
      Type: "POST",
    });

    if (response.StatusCode === 200) {
      toast.success("Updated successfully");
    } else {
      toast.error("Update failed: " + response.Message);
    }
  };

  const columns = [
    {
      name: "S.N.",
      width: "60px",
      cell: (row, index) => index + 1,
      center: true,
    },
    {
      name: "Full Name",
      selector: (row) => row.FullName,
    },


    {
      name: "OT Amount",
      center: true,
      cell: (row) => (
        <input
          type="number"
          value={row.OTValue}
          onChange={(e) => handleInputChange(e, row, "OTValue")}
          className="form-control form-control-sm"
        />
      ),
    },
  ];

  return (
    <>
      <div className="container-fluid classatten-wrapper  mt-3 ps-4 pe-4">
         <div className="row mt-3">
                  <div className="page-header">
                    <div className="text-start  page-title">
                      {mode === "en" ? "Over Time" : "कागजात"}
                    </div>
                    <div className="page-date">
                      <div className="sec-content">
                        <span className="me-2 ">Expires in: {expires} </span>
                        <FaRegCalendarAlt /> {todayDate} <span>|</span>{" "}
                        {mode === "en" ? "Fiscal Year" : "वित्तीय वर्ष"} :{" "}
                        {fiscalYear.StartDate}
                        {fiscalYear.EndDate}
                      </div>
                    </div>
                  </div>
                  <hr className="title-hr" />
                </div>
        <div className="row mb-3">
           <div className="">
                            <div className="d-flex uk-flex-wrap uk-flex-middle uk-flex-right">
                              <div className="btn-addlnote mt-3">
                                <button
                                  type="button"
                                  class="btn btn-sm"
                                  style={{
                                    background: "var(--button-color)",
                                    color: "white",
                                  }}
                                  onClick={handleSave}
                                >
                                 
                                  {mode === "en"
                                    ? "Update"
                                    : "उपस्थिति इन्टरनेटको मार्ग थप्नुहोस्"}
                                </button>
                              </div>
                            </div>
                          </div>

        </div>

        {loading ? (
          <Spinner />
        ) : (
          <DataTable
            columns={columns}
            data={dataList}
            customStyles={customStyles}
            pagination
            responsive
            striped
             paginationRowsPerPageOptions={[10, 20, 50, 100]} // Customizable options
                    fixedHeaderScrollHeight="335px"
                    highlightOnHover
                    pointerOnHover
                    progressPending={loading}
                    dense
                    fixedHeader
          />
        )}
      </div>
    </>
  );
}
